export const ALL_SITES = { id: 0, value: '企業全体' }
